var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{attrs:{"name":"portal-errors","url":_vm.url,"columns":_vm.columns,"title":"Portal Errors","pageSize":50,"requestTimeout":120000,"expandedOptions":{
    enabled: true,
    template: 'portal-error-details',
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }